export default __webpack_public_path__ + "static/media/misc-closet2-1920w.e5bda3a8.png";